module.exports = function() {
  return new Worker(__webpack_public_path__ + "b5827c9f76309825b80f.worker.js");
};